import * as React from 'react';

import styles from './styles.module.scss';

export default class DownEmployeeBadge extends React.PureComponent {

	render() {
		return (
			<div className={styles['down-resource-badge']}>
				<span className="icon-user" />
			</div>
		);
	}
}
